import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

import searchItems from 'utils/searchItems';

import { getDebouncedSearchValue } from 'store/search/selectors';

import { getCompany } from './company.selectors';

const selectAudioRecordings = createSelector(getCompany, ({ audioRecordings }) => audioRecordings);

const selectAudioRecordingsValues = createSelector(selectAudioRecordings, Object.values);

export const selectFilteredAudioRecordings = createSelector(
  getDebouncedSearchValue,
  selectAudioRecordingsValues,
  searchItems(audioRecording => [audioRecording.name]),
);

export const selectCompanyAudioRecordingById = memoizeOne(id =>
  createSelector(selectAudioRecordings, audioRecordings => audioRecordings[id]),
);
